import { useCallback, useMemo } from "react";

import { CurrencyType } from "@/lib/gql/__generated__/graphql";

import { useProductPlanFormModelContext } from "../../../../../context";

export const usePlanCoSleeping = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();

	const isCoSleepingKidsPriceActive = useMemo(
		() => viewModel.isCoSleepingKidsPriceActive.value,
		[viewModel.isCoSleepingKidsPriceActive.value],
	);

	/**
	 * @todo 適切な定義へ変更
	 * 「添い寝の子供の料金を設定する」のフラグを変更
	 */
	const onChangeIsCoSleepingKidsPriceActive = useCallback(
		(value: boolean) => {
			onSetViewModel([
				{ key: "isCoSleepingKidsPriceActive", value: { ...viewModel.isCoSleepingKidsPriceActive, value } },
			]);
		},
		[onSetViewModel, viewModel.isCoSleepingKidsPriceActive],
	);

	/**
	 * @todo 適切な定義へ変更
	 * 「添い寝の子供一人当たり」の料金を変更
	 */
	const onChangeCoSleepingKidsPrice = useCallback(
		(value: number | undefined) => {
			onSetViewModel([
				{
					key: "coSleepingKidsPrice",
					value: {
						amount: {
							isEdited: true,
							value: value!, // バリデーションエラーを出すため未入力（undefined）を一時的に許容している
						},
						currencyType: { isEdited: true, value: CurrencyType.Jpy },
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		isCoSleepingKidsPriceActive,
		amount: viewModel.coSleepingKidsPrice?.amount,
		onChangeIsCoSleepingKidsPriceActive,
		onChangeCoSleepingKidsPrice,
	};
};
